import { InputDatev2 } from "@itandi/itandi-bb-ui/InputDatev2";
import { useFormContext, useWatch } from "react-hook-form";
import type { DealSearchCondition } from "~/models/Deal";
import { toDate as convertToDate, formatHyphenDate } from "~/utils/DateUtil";

type Props = {
	attributeName:
		| "constructionMinStartDate"
		| "constructionMaxStartDate"
		| "constructionMinEndDate"
		| "constructionMaxEndDate"
		| "estimationRequestedMinDate"
		| "estimationRequestedMaxDate"
		| "inspectionMinDate"
		| "inspectionMaxDate"
		| "surveyMinDate"
		| "surveyMaxDate"
		| "registrationMinDate"
		| "registrationMaxDate"
		| "updatedMinDate"
		| "updatedMaxDate"
		| "sendEstimateMinDate"
		| "sendEstimateMaxDate"
		| "orderMinDate"
		| "orderMaxDate"
		| "constructionReportedMinDate"
		| "constructionReportedMaxDate"
		| "completedMinDate"
		| "completedMaxDate";
	disabled?: boolean;
};

export function SearchConditionDate({
	attributeName,
	disabled = false
}: Props) {
	const { setValue, control } = useFormContext<DealSearchCondition>();
	const watchedValue: string | undefined = useWatch({
		control,
		name: attributeName
	});
	const dateValue = convertToDate(watchedValue ?? null);
	const onDateChange = (value: Date | null): void => {
		setValue(attributeName, formatHyphenDate(value) ?? undefined);
	};
	return (
		<InputDatev2
			disabled={disabled}
			onChange={onDateChange}
			placeholder="年/月/日"
			value={dateValue}
		/>
	);
}
